import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule, MatDialogTitle } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatRadioModule } from '@angular/material/radio';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
    imports: [
        MatInputModule,
        MatFormFieldModule,
        MatIconModule,
        MatButtonModule,
        MatMenuModule,
        MatCheckboxModule,
        MatCardModule,
        MatTooltipModule,
        MatSelectModule,
        MatDatepickerModule,
        MatDialogModule,
        MatSlideToggleModule,
        MatExpansionModule,
        MatRadioModule,
        MatTabsModule,
        MatToolbarModule,
        MatDialogTitle,
        MatButtonToggleModule,
        MatProgressSpinnerModule,
    ],
    exports: [
        MatInputModule,
        MatFormFieldModule,
        MatIconModule,
        MatButtonModule,
        MatMenuModule,
        MatCheckboxModule,
        MatCardModule,
        MatTooltipModule,
        MatSelectModule,
        MatDatepickerModule,
        MatDialogModule,
        MatSlideToggleModule,
        MatExpansionModule,
        MatRadioModule,
        MatTabsModule,
        MatToolbarModule,
        MatDialogTitle,
        MatButtonToggleModule,
        MatProgressSpinnerModule,
    ],
})
export class AngularMaterialModule { }
